import { Box, IconButton, LinearProgress, makeStyles, Zoom } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import React, { useEffect, useState } from "react";
import Unicorn_Jumping_Slower from "../../assets/images/Unicorn_Jumping_Slower.gif";

const useStyles = makeStyles({
  progressRoot: {
    height: "6px",
    position: "absolute",
    width: "calc(100% - 32px)",
    bottom: "8px",
    left: "16px",
  },
  progressColorPrimary: {
    backgroundColor: "rgba(255, 255, 255, 0.32)",
  },
  progressBarColorPrimary: {
    backgroundColor: "rgba(255, 255, 255, 0.7)",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  iconButton: {
    cursor: "pointer",
    padding: 0,
    position: "absolute",
    right: "2rem",
    top: "2rem",
    zIndex: 100,
    height: "48px",
    width: "48px",
  },
  imgContainer: {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
});

const INTERVAL_MS = 100;

interface XmasSpecialDialogProps {
  open: boolean;
  onClose: (b: boolean) => void;
}

const XmasSpecialDialog: React.FC<XmasSpecialDialogProps> = ({ open, onClose }) => {
  const [progress, setProgress] = useState(100);
  const [timer, setTimer] = useState<NodeJS.Timeout | null>();

  const classes = useStyles();

  const resetProgress = () => {
    setProgress(100);
  };

  const dateWithinXmasRange = () => {
    const today = new Date();
    const currentMonth = today.getMonth() + 1;
    const currentDay = today.getDate();
    // Xmas content valid from Dec. 16th to Jan. 6th
    const decemberCondition = currentMonth === 12 && currentDay > 14;
    const januaryCondition = currentMonth === 1 && currentDay < 7;

    return decemberCondition || januaryCondition;
  };

  const startTimer = () => {
    const newTimer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress <= 0) {
          clearInterval(newTimer);
          setTimeout(() => {
            resetProgress();
            onClose(false);
          }, 500);
          return 0;
        }
        return prevProgress - 1.6;
      });
      setTimer(newTimer);
    }, INTERVAL_MS);
  };

  const handleClick = () => {
    if (timer) {
      clearInterval(timer);
    }
    resetProgress();
  };

  useEffect(() => {
    if (open) {
      startTimer();
    }
  }, [open]);

  if (dateWithinXmasRange()) {
    return (
      <Zoom in={open} timeout={1000}>
        <Box style={{ position: "fixed", top: 0, backgroundColor: "white", zIndex: 10000, height: "100vh" }}>
          <IconButton
            className={classes.iconButton}
            onClick={() => {
              onClose(false);
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box className={classes.imgContainer} onClick={handleClick}>
            <img src={Unicorn_Jumping_Slower} alt="Unicorn Jumping GIF" style={{ width: "inherit" }} />
            <LinearProgress color="secondary" className={classes.progressRoot} variant="determinate" value={progress} />
          </Box>
        </Box>
      </Zoom>
    );
  }

  return <></>;
};

export default XmasSpecialDialog;
